import { render, staticRenderFns } from "./ContentAddEditPanel.vue?vue&type=template&id=2e365447&scoped=true&"
import script from "./ContentAddEditPanel.vue?vue&type=script&lang=js&"
export * from "./ContentAddEditPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContentAddEditPanel.vue?vue&type=style&index=0&id=2e365447&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e365447",
  null
  
)

export default component.exports